export default __webpack_public_path__ + "static/chillingo-74f629ef13ed20c65b26dc22a7782009.svg";